export default __webpack_public_path__ + "static/media/foundernest-logo.4c9701cf.svg";